import React from 'react'
import styled from 'styled-components'
import Card from './Card'
import { InnerLayout } from './Layout'

import check from '../../Assets/img/check.svg';
import checkDisabled from '../../Assets/img/check-disabled.svg';
import DetailCard from './DetailCard';
import { Container } from "react-bootstrap";
import Particle from "../Particle";

import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";

const ThreeDWebCard = () => {

  const navigate = useNavigate(); // Initialize navigate

  const handleClick = () => {
    navigate("/courses"); // This will navigate to the "/another-page" route
  };

    
    return (
        <Container >
      <ParticleWrapper>
                <Particle />
            </ParticleWrapper>
      <PaymentStyled id='pricing'>
         <InnerLayout>
            <div data-aos='fade-down-right'>
               <h3 className="small-heading">
               Build & Design Interactive 3D-Web Training 
               </h3>
               <p className="c-para">Transforming Web Experiences with 3D Technology </p>
               <p>The Build & Design Interactive 3D-Web Training at Choicest Fruit® empowers youth ages 14–24 to create immersive, interactive, and visually stunning web experiences. Perfect for beginners or those looking to enhance their portfolio, this training combines creativity, technical skills, and ethical design principles to bring 3D graphics to life on the web.
                  Participants will learn how to integrate 3D visuals into websites, applications, and games, enhancing user engagement, storytelling, and interactivity while mastering industry-standard tools and frameworks.</p>
            </div>
            <Button onClick={handleClick}>View Trainings</Button>
            <div className='card-con'>
               <Card
                  account={'What You’ll Learn'}                 
                  text={'3D-Web Training isn’t just about impressive visuals, we give our participants the skills to innovate, tell stories, and build interactive experiences that engage and inspire.'}
                  button={'Register Here'}
              
                  link="https://docs.google.com/forms/d/e/1FAIpQLSfyUZt4peUyGezMs72Taa9NH0s-IayV7VJpHF8kV7YQbZ1tpg/viewform"
                //   active={active}
                //   inactive={inactive}
                  check={check}
                  checkDis={checkDisabled}
                  text1={'3D Web Development Fundamentals: Understand the relationship between WebGL and Three.js for interactive 3D graphics in web browsers.'}
                  text2={'Three.js Mastery: Create stunning 3D web applications using the popular JavaScript framework, including logos, texts, animations, and interactive elements.'}
                  text3={'3D Application Development: Write simple to complex 3D applications, mastering both the theory and practical skills required for dynamic, browser-based 3D experiences.'}
                  text4={'Blender Integration: Learn to create Blender models and export entire Blender scenes for use in 3D web projects.'}
                  text5={'Interactive & Immersive Design: Incorporate 3D graphics to enhance portfolios, product pages, games, and other web-based applications.'}
                  text6={'Cross-Browser 3D Graphics: Develop skills in WebGL and other modern web technologies, ensuring projects work seamlessly across platforms.'}
                
               />

               <Card
                  account={'Payment'}
                  amount={'$350'}
                  text={'A seamless and user-friendly payment integration.'}
                button={'Pay Here'}
                link="https://checkout.square.site/merchant/MLAY6G9T625V1/checkout/JMI22RTVC4CSPJN3OBQK53U6"
                 
                //   active={active}
                //   inactive={inactive}
                  check={check}
                  checkDis={checkDisabled}
                  text1={'Training Length: 2 months.'}
                  text2={'Experience: No programming experience needed.'}
                  text3={'Certification: Certificate awarded upon completion.'}
                  text4={'Training Setting: In-Person|Remote|Hybrid.'}
                  text5={'Software Requirements: No paid software required.'}
                  text6={'Training Requirements: Access to internet.'}               
                 />

           </div>
         </InnerLayout>
            </PaymentStyled>
            <Container>
                <DetailCard/>
                </Container>
            </Container>
      
   )
}

const ParticleWrapper = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;  // Place it behind all other content
`;

const PaymentStyled = styled.section`
 .card-con {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 2rem; /* Reduce the gap between the cards */
    padding-top: 4rem; /* Reduce top padding */
    
    /* Optional: Use max-width to control the card's maximum size */
    max-width: 1200px;
    margin: 0 auto;
        
    @media screen and (max-width: 689px) {
      grid-template-columns: 1fr; /* Stack cards on mobile */
    }
  }

  p {
    text-align: center;
  }
`



export default ThreeDWebCard
